<template>
  <el-container>
    <el-header>
      <div class="nav-header">
        <el-row>
          <el-col :span="12">
            <div class="title" v-text="title"></div>
          </el-col>
          <el-col :span="12">
            <div class="layout-right">
              <el-button @click.once="handleBack">返回修改</el-button>
              <el-button type="primary" @click.once="handleSubmit">
                确认无误，提交
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-main>
      <div><Base ref="Base" @set-title="handleTitle"></Base></div>
    </el-main>
  </el-container>
</template>

<script>
import Base from './components/Base.vue';
import { flowSubmit } from '@/api/position/mavin/flow.js';

export default {
  data() {
    return {
      title: '...'
    };
  },
  components: {
    Base
  },
  methods: {
    handleTitle(title) {
      this.title = title;
    },
    handleSubmit() {
      this.$confirm('是否要提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        flowSubmit(this.$route.params.mavinEid).then(() => {
          this.msgSuccess('提交成功！', function () {
            window.close();
          });
        });
      });
    },
    handleBack() {
      this.$router.push(`/position/base/${this.$route.params.mavinEid}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.layout-right {
  padding: 10px;
}
</style>
